/* Cart-drawer recommendations init. Loaded once per page (deferred) from
   layout/theme.liquid — the drawer's innerHTML is swapped on cart update
   without re-running embedded scripts, so this runs at page level and
   re-initialises via a MutationObserver on the cart-drawer element.
   Idempotent by that design. No Liquid values. */
            /* Initialize cart drawer recommendations after content loads via AJAX */
            (function () {
              /* Don't cache the element: cart.js replaces <cart-drawer-items> on
                 cartUpdate (including coupon apply/remove), so the reference goes
                 stale and listeners detach with the old DOM. Re-query every time. */
              function getDrawerRecsEl() {
                return document.querySelector('.cart-recs--drawer');
              }

              function initDrawerRecs() {
                var drawerRecsEl = getDrawerRecsEl();
                if (!drawerRecsEl) return;
                var slider = drawerRecsEl.querySelector('.cart-recs__slider');
                if (!slider) return;

                /* Slider */
                if (!slider._cartRecsSliderInit) {
                  slider._cartRecsSliderInit = true;
                  var prevBtn = drawerRecsEl.querySelector('.cart-recs__arrow--prev');
                  var nextBtn = drawerRecsEl.querySelector('.cart-recs__arrow--next');
                  if (prevBtn && nextBtn) {
                    function getSlides() { return slider.querySelectorAll('.cart-recs__slide'); }
                    /* Use absolute slide.offsetLeft snap points — relative
                       scrollBy() fights scroll-snap-mandatory after a
                       hand-scroll. Buttons stay always-enabled because
                       on first load the slider is freshly inserted and
                       its scrollLeft/scrollWidth aren't reliable —
                       gating the buttons on those values used to lock
                       the prev arrow disabled until a page refresh. */
                    function getCurrentSlideIndex() {
                      var slides = getSlides();
                      if (slides.length === 0) return 0;
                      var scrollLeft = slider.scrollLeft;
                      var best = 0, bestDelta = Infinity;
                      for (var i = 0; i < slides.length; i++) {
                        var d = Math.abs(slides[i].offsetLeft - scrollLeft);
                        if (d < bestDelta) { bestDelta = d; best = i; }
                      }
                      return best;
                    }
                    function scrollToSlide(idx) {
                      var slides = getSlides();
                      if (slides.length === 0) return;
                      idx = Math.max(0, Math.min(slides.length - 1, idx));
                      slider.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
                    }
                    prevBtn.disabled = false;
                    nextBtn.disabled = false;
                    prevBtn.addEventListener('click', function () { scrollToSlide(getCurrentSlideIndex() - 1); });
                    nextBtn.addEventListener('click', function () { scrollToSlide(getCurrentSlideIndex() + 1); });
                  }
                }

                /* Swatches — guard per card so re-init doesn't double-bind */
                drawerRecsEl.querySelectorAll('[data-product-card]').forEach(function (card) {
                  if (card._cartRecsSwatchInit) return;
                  card._cartRecsSwatchInit = true;
                  var variantsJson = card.querySelector('[data-variants-json]');
                  if (!variantsJson) return;
                  var variants = JSON.parse(variantsJson.textContent);

                  card.addEventListener('click', function (e) {
                    var btn = e.target.closest('[data-swatch-btn]');
                    if (!btn) return;

                    var optionValue = btn.dataset.optionValue;
                    var swatchGroup = btn.closest('.cart-recs__swatch-list');
                    swatchGroup.querySelectorAll('[data-swatch-btn]').forEach(function (b) {
                      b.classList.remove('cart-recs__swatch--active');
                    });
                    btn.classList.add('cart-recs__swatch--active');

                    var label = btn.closest('.cart-recs__swatches').querySelector('[data-swatch-value]');
                    if (label) label.textContent = optionValue;

                    var selectedOptions = {};
                    card.querySelectorAll('[data-swatch-btn].cart-recs__swatch--active').forEach(function (b) {
                      selectedOptions[b.dataset.optionName] = b.dataset.optionValue;
                    });

                    var matched = variants.find(function (v) {
                      for (var key in selectedOptions) {
                        var found = false;
                        for (var i = 0; i < v.options.length; i++) {
                          if (v.options[i] === selectedOptions[key]) { found = true; break; }
                        }
                        if (!found) return false;
                      }
                      return true;
                    });
                    if (!matched) return;

                    if (matched.featured_image && matched.featured_image.src) {
                      var img = card.querySelector('[data-variant-image]');
                      if (img) { img.setAttribute('src', matched.featured_image.src); img.removeAttribute('srcset'); }
                    }
                    var priceEl = card.querySelector('[data-variant-price]');
                    if (priceEl && window.Shopify) {
                      priceEl.textContent = Shopify.formatMoney(matched.price).replace(/\.00$/, '').replace('Rs.', '₹').replace('Rs', '₹');
                    }
                    var compareEl = card.querySelector('.cart-recs__price-compare');
                    var saveEl = card.querySelector('.cart-recs__save-badge');
                    if (matched.compare_at_price && matched.compare_at_price > matched.price) {
                      if (compareEl) { compareEl.textContent = Shopify.formatMoney(matched.compare_at_price).replace(/\.00$/, '').replace('Rs.', '₹').replace('Rs', '₹'); compareEl.style.display = ''; }
                      if (saveEl) { saveEl.textContent = 'SAVE ' + Shopify.formatMoney(matched.compare_at_price - matched.price).replace(/\.00$/, '').replace('Rs.', '₹').replace('Rs', '₹'); saveEl.style.display = ''; }
                    } else {
                      if (compareEl) compareEl.style.display = 'none';
                      if (saveEl) saveEl.style.display = 'none';
                    }
                    var addBtn = card.querySelector('[data-add-to-cart]');
                    if (addBtn) {
                      addBtn.dataset.variantId = String(matched.id);
                      addBtn.disabled = !matched.available;
                      var spanEl = addBtn.querySelector('span:not(.cart-recs__added-msg)');
                      if (spanEl) spanEl.textContent = matched.available ? 'Add' : 'Sold Out';
                    }
                  });
                });

                /* Add to cart (delegated, once per container) */
                if (!drawerRecsEl._cartRecsATC) {
                  drawerRecsEl._cartRecsATC = true;
                  drawerRecsEl.addEventListener('click', function (e) {
                    var btn = e.target.closest('[data-add-to-cart]');
                    if (!btn || btn.disabled || btn.classList.contains('loading')) return;

                    var variantId = btn.dataset.variantId;
                    if (!variantId) return;

                    btn.classList.add('loading');
                    var svgEl = btn.querySelector('svg');
                    var spanEl = btn.querySelector('span:not(.cart-recs__added-msg)');
                    if (svgEl) svgEl.style.display = 'none';
                    if (spanEl) spanEl.style.display = 'none';
                    var addedMsg = btn.querySelector('.cart-recs__added-msg');

                    /* Special Prices marks the line with the property its discount
                       reads. Build the line through the shared helper, never
                       inline: the card's advertised saving only materialises if
                       this property ships, and a hand-rolled line silently drops
                       it while the card still promises the discount. */
                    fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ items: [window.SpecialPrices ? window.SpecialPrices.lineItemFor(variantId, btn) : { id: Number(variantId), quantity: 1 }] })
                    })
                    .then(function (res) {
                      if (!res.ok) throw new Error('Add to cart failed');
                      return res.json();
                    })
                    .then(function () {
                      return fetch((window.Shopify.routes.root || '/') + 'cart.js')
                        .then(function (r) { return r.json(); })
                        .then(function (cartData) {
                          /* Publish cartUpdate so cart-drawer-items re-renders */
                          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                              source: 'cart-recommendations',
                              cartData: cartData,
                              variantId: variantId
                            });
                          }

                          /* Header count is re-rendered centrally by
                             cart.js onCartUpdate() (renderCartIconBubble) via
                             the cartUpdate above — no manual patch needed. */

                          /* Refresh drawer recommendations after delay */
                          var newFirstProductId = cartData.items && cartData.items[0]
                            ? cartData.items[0].product_id : null;
                          if (newFirstProductId) {
                            setTimeout(function () {
                              drawerRecsEl.dataset.productId = String(newFirstProductId);
                              if (typeof drawerRecsEl.loadRecommendations === 'function') {
                                drawerRecsEl.loadRecommendations(newFirstProductId);
                              } else {
                                fetch(drawerRecsEl.dataset.url + '&product_id=' + newFirstProductId + '&section_id=' + drawerRecsEl.dataset.sectionId)
                                  .then(function (r) { return r.text(); })
                                  .then(function (text) {
                                    var html = document.createElement('div');
                                    html.innerHTML = text;
                                    var newRecs = html.querySelector('product-recommendations');
                                    if (newRecs && newRecs.innerHTML.trim().length) {
                                      drawerRecsEl.innerHTML = newRecs.innerHTML;
                                      initDrawerRecs();
                                    }
                                  });
                              }
                            }, 2200);
                          }
                        });
                    })
                    .then(function () {
                      btn.classList.remove('loading');
                      if (addedMsg) {
                        addedMsg.hidden = false;
                        if (svgEl) svgEl.style.display = 'none';
                        if (spanEl) spanEl.style.display = 'none';
                      }
                      setTimeout(function () {
                        if (addedMsg) addedMsg.hidden = true;
                        if (svgEl) svgEl.style.display = '';
                        if (spanEl) spanEl.style.display = '';
                      }, 2000);
                    })
                    .catch(function (err) {
                      console.error('Drawer add to cart error:', err);
                      btn.classList.remove('loading');
                      if (svgEl) svgEl.style.display = '';
                      if (spanEl) spanEl.style.display = '';
                    });
                  });
                }
              }

              /* Observe a stable parent that is NOT replaced on cart re-render.
                 cart.js replaces <cart-drawer-items> via replaceWith() on cartUpdate,
                 so observing the recs element (or cart-drawer-items) itself dies
                 with the old DOM. cart-drawer is the outermost element that stays
                 put across re-renders. */
              var stableRoot = document.querySelector('cart-drawer') || document.body;
              var observer = new MutationObserver(function () {
                if (getDrawerRecsEl()) initDrawerRecs();
              });
              observer.observe(stableRoot, { childList: true, subtree: true });

              /* Also init if content already loaded */
              initDrawerRecs();

              /* NOTE: no cartUpdate subscribe here. The MutationObserver above
                 is the re-init path across cart re-renders. In the inline
                 original this script ran at parse time — before the deferred
                 pubsub.js defined subscribe — so a cartUpdate subscription was
                 never registered (dead). As a deferred asset it WOULD register,
                 which would re-fetch recommendations redundantly with the
                 observer (and, on an Upgrade & Save click, against the
                 about-to-be-replaced node). Kept dead to preserve behavior. */
            })();
